import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

import { Button, Text } from "../../../../../../../../mads";
import { Information } from "../../../../../../../../mads/icons";

interface HighlightedAttributesTooltipProps {
  label: string;
  onPress: () => void;
  shouldAddSpace?: boolean;
}

const HighlightedAttributesTooltip = ({
  label,
  onPress,
  shouldAddSpace = false,
}: HighlightedAttributesTooltipProps) => {
  return (
    <>
      <Button
        variant="text"
        iconOnly={true}
        iconBefore={<Information color={colors.foreground.strong} aria-hidden size="xs" />}
        aria-label={label}
        onPress={onPress}
        sx={styles.button}
      />
      {shouldAddSpace && <Text>,&nbsp;</Text>}
    </>
  );
};

const styles = StyleSheet.create({
  button: {
    paddingLeft: 4,
  },
});

export default HighlightedAttributesTooltip;
